var React = require('react');

function Down (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z","fill":"currentColor","key":1})]);
}

Down.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Down;

Down.default = Down;
